import Swal from "sweetalert2";
import { jwtDecode } from "jwt-decode";


const { REACT_APP_URL_API } = process.env;

//const REACT_APP_URL_API = `${REACT_APP_SERVER_API}:${REACT_APP_PORT_API}/${REACT_APP_PATH_API}`
// const REACT_APP_URL_API = `${REACT_APP_SERVER_API}:${REACT_APP_PORT_API}/${REACT_APP_PATH_API}/${REACT_APP_PATH_API_USER}`;



export const POST_CREDENTIALS = 'POST_CREDENTIALS';
export const GET_CREDENTIALS = 'GET_CREDENTIALS';
export const GET_USER = 'GET_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const GET_COURSES = 'GET_COURSES';
export const GET_USER_COURSES = 'GET_USER_COURSES';
export const GET_COURSE_BY_PK = 'GET_COURSE_BY_PK';
export const LOGOUT_USER = 'LOGOUT_USER';



export const ADD_IN_PROGRESS_COURSE = 'ADD_IN_PROGRESS_COURSE';
export const GET_USER_PROGRESS_SUCCESS = 'GET_USER_PROGRESS_SUCCESS';
export const MARK_VIDEO_COMPLETE_SUCCESS = 'MARK_VIDEO_COMPLETE_SUCCESS';
export const UNMARK_VIDEO_COMPLETE_SUCCESS = 'UNMARK_VIDEO_COMPLETE_SUCCESS';
export const GET_NEWS = 'GET_NEWS';





export const getRegister = (isSignUp, setIsSignUp) => {
    return async (dispatch) => {
        try {
            const response = await fetch(`${REACT_APP_URL_API}/user/auth/signup`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify(isSignUp),
            });
            if (!response.ok) {
                console.log('Error en la respuesta del servidor:', response.statusText);
                response.json().then((data) => {
                    if (data.message.includes('El usuario ya existe')) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Ya existe un usuario con este correo',
                            timer: 2000,
                        });
                    } else if (data.message.includes('Faltan datos obligatorios')) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Faltan datos obligatorios',
                            timer: 2000,
                        });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Error en el registro, intenta nuevamente',
                            timer: 1500,
                        });
                    }
                });
                throw new Error('Error en la solicitud POST');
            }
            const data = await response.json();
            dispatch({
                type: POST_CREDENTIALS,
                payload: data,
            });
            // if (data.token) {
            //     localStorage.setItem('token', data.token);
            // }
            Swal.fire({
                icon: 'success',
                title: 'Registro exitoso',
                text: 'Bienvenido a la plataforma!, revisa tu correo para verificar tu cuenta.',
                timer: 4500,
                showConfirmButton: false,
            })
                .then(() => {
                    setIsSignUp({ name: "", email: "", password: "" });
                });
        } catch (error) {
            console.log('Error al enviar la solicitud POST:', error);
        }
    };
};

export const getSignIn = (isSignIn, setIsSignIn, navigate) => {
    return async (dispatch) => {
        try {
            const response = await fetch(`${REACT_APP_URL_API}/user/auth/signin`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify(isSignIn),
            });
            if (response.status === 403) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Por favor, verifica tu correo electrónico antes de iniciar sesión',
                    timer: 3000,
                });
                return;
            }
            if (!response.ok) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Credenciales inválidas',
                    timer: 2000,
                });
                throw new Error('Error en la solicitud POST');
            }
            const data = await response.json();
            dispatch({
                type: GET_CREDENTIALS,
                payload: data,
            });
            if (data.token) {
                localStorage.setItem('token', data.token);
                // const decodeUserName = jwtDecode(data.token);
                // const userName = decodeUserName.userName;
                Swal.fire({
                    icon: 'success',
                    title: 'Inicio de sesión exitoso',
                    text: `Bienvenido de nuevo, ${data.name}!`,
                    timer: 2000,
                    showConfirmButton: false,
                })
                    .then(() => {
                        setIsSignIn({ email: "", password: "" });
                        navigate('/profile');
                        // Ocultar el menu login en react
                        document.getElementById('login').style.display = 'none';
                    });
            }
        } catch (error) {
            console.log('Error al enviar la solicitud POST:', error);
        }
    };
}


export const getCourses = (limit = 10, offset = 0, title = '') => {
    return async (dispatch) => {
        try {
            let url = `${REACT_APP_URL_API}/courses/all?limit=${limit}&offset=${offset}`
            if (title) url += `&title=${encodeURIComponent(title)}`;

            const response = await fetch(url)
            console.log(response);

            if (!response.ok) {
                throw new Error('Error en la solicitud GET');
            }
            const data = await response.json();
            console.log('Respuesta del server', data);

            dispatch({
                type: 'GET_COURSES',
                payload: data,
            });
        } catch (error) {
            console.log('Error al enviar la solicitud GET:', error);
        }
    };
};

// Action para solicitar información del usuario en el perfil
export const getUser = (token) => {
    return async (dispatch) => {
        try {
            const response = await fetch(`${REACT_APP_URL_API}/user/profile`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                credentials: 'include',
            });
            if (!response.ok) {
                throw new Error('Error en la solicitud GET');
            }
            const data = await response.json();

            console.log('Datos del usuario obtenidos:', data);

            dispatch({
                type: 'GET_USER',
                payload: data,
            });
        } catch (error) {
            console.log('Error al enviar la solicitud GET:', error);
        }
    };
}

export const getUserCourses = (token) => {
    console.log('Token en getUserCourses:', token);
    
    return async (dispatch) => {
        try {
            const response = await fetch(`${REACT_APP_URL_API}/course/`, { 
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                credentials: 'include',
            });
            console.log('Respuesta del servidor:', response);
            if (!response.ok) {
                if (response.status === 404) {
                    Swal.fire({
                        icon: 'info',
                        title: 'Sin cursos inscritos',
                        text: 'No tienes cursos inscritos en este momento.',
                        timer: 2000,
                        showConfirmButton: false,
                    });
                    return;
                }
                throw new Error('Error en la solicitud GET');
            }

            const data = await response.json();
            console.log('Datos de los cursos del usuario obtenidos:', data);
            dispatch({
                type: GET_USER_COURSES,
                payload: data,
            });
        }
        catch (error) {
            console.log('Error al enviar la solicitud GET:', error);
        }
    }
}

// Action para obtener un curso por su ID
// Esta acción se utiliza para cargar un curso específico en la página del curso
export const getCourseByPk = (id, token) => {
    return async (dispatch) => {
        try {
            const response = await fetch(`${REACT_APP_URL_API}/course/${id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                credentials: 'include',
            });
            console.log('Respuesta del servidor al obtener curso por ID:', response);
            if (!response.ok) {
                throw new Error('Error en la solicitud GET');
            }
            const data = await response.json();
            dispatch({
                type: GET_COURSE_BY_PK,
                payload: data,
            });
            console.log('Datos del curso obtenidos por ID:', data);
        } catch (error) {
            console.log('Error al enviar la solicitud GET:', error);
        }
    };
};

// Action para agregar un curso en progreso solo si el usuario ha iniciado la reproducción del curso
export const addInProgressCourse = (courseId) => ({
    type: ADD_IN_PROGRESS_COURSE,
    payload: courseId,
});

export const updateUserProfile = (userData, token) => {
    return async (dispatch) => {
        try {
            const response = await fetch(`${REACT_APP_URL_API}/user/profile/update`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                credentials: 'include',
                body: JSON.stringify(userData),
            });
            if (!response.ok) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudo actualizar el perfil. Por favor, intenta nuevamente.',
                    timer: 2000,
                    showConfirmButton: false,
                });
                throw new Error('Error en la solicitud PUT');
            }
            const data = await response.json();
            dispatch({
                type: UPDATE_USER,
                payload: data,
            });
            Swal.fire({
                icon: 'success',
                title: 'Perfil actualizado',
                text: 'Tus datos se han actualizado correctamente.',
                timer: 2000,
                showConfirmButton: false,
            });
        } catch (error) {
            console.log('Error al enviar la solicitud PUT:', error);
        }
    };
}


// Action que se encarga de cerrar sesión
export const LogoutUser = (navigate) => {
    return async (dispatch) => {
        try {
            if (!localStorage.getItem('token')) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Sesión inactiva',
                    text: 'La sesión ha caducado. Por favor, inicia sesión nuevamente.',
                    timer: 3000,
                    showConfirmButton: false,
                });
                return;
            }
            localStorage.removeItem('token');
            dispatch({
                type: 'LOGOUT_USER',
                payload: null,
            });
            Swal.fire({
                icon: 'success',
                title: 'Sesión cerrada',
                text: 'Has cerrado sesión correctamente.',
                timer: 2000,
                showConfirmButton: false,
            });
            navigate('/login');
            document.getElementById('login').style.display = 'block';
        } catch (error) {
            console.log('Error al enviar la solicitud POST:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo cerrar sesión. Inténtalo de nuevo más tarde.',
                timer: 2000,
                showConfirmButton: false,
            });
        }
    }
};


export const getNews =()=>{

    return async (dispatch)=>{
        try {
            let url = `${REACT_APP_URL_API}/news/allNews?published=true`
            const response = await fetch(url);
            
            console.log(response);

            if(!response.ok){
                throw new Error('Error en la solicitud GET')
            }
            const data = await response.json()
            console.log('respuesta del server',data);
            dispatch({
                type: 'GET_NEWS',
                payload: data,
            })
        } catch (error) {
            console.log('Error al enviar la solicitu get:', error);            
        }
    }
}

export const getUserProgress = (courseId, token) => {
    return async (dispatch) => {
        try {
            const response = await fetch(`${getUserProgress}/${courseId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                credentials: 'include',
            });
            if (!response.ok) {
                throw new Error('Error en la solicitud de progreso');
            }
            const data = await response.json();
            dispatch({
                type: GET_USER_PROGRESS_SUCCESS,
                payload: data,
            });
        } catch (error) {
            console.log('Error fetching user progress:', error);
        }
    };
};

export const markVideoComplete = (videoId, courseId, token) => {
    return async (dispatch) => {
        try {
            const response = await fetch(`${REACT_APP_URL_API}/complete` , {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                credentials: 'include',
                body: JSON.stringify({ videoId, courseId }),
            });
            if (!response.ok) {
                throw new Error('Error al marcar video como completo');
            }
            const data = await response.json();
            // Assuming the backend returns the updated progress for the video
            dispatch({
                type: MARK_VIDEO_COMPLETE_SUCCESS,
                payload: { videoId }, // Or payload: data if the API returns the updated video progress object
            });
        } catch (error) {
            console.log('Error marking video as complete:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo marcar el video como completo. Inténtalo de nuevo más tarde.',
                timer: 2000,
                showConfirmButton: false,
            });
        }
    };
};

export const unmarkVideoComplete = (videoId, courseId, token) => {
    return async (dispatch) => {
        try {
            const response = await fetch(`${REACT_APP_URL_API}/uncomplete` , {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                credentials: 'include',
                body: JSON.stringify({ videoId, courseId }),
            });
            if (!response.ok) {
                throw new Error('Error al desmarcar video como completo');
            }
            const data = await response.json();
            dispatch({
                type: UNMARK_VIDEO_COMPLETE_SUCCESS,
                payload: { videoId },
            });
        } catch (error) {
            console.log('Error unmarking video as complete:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo desmarcar el video como completo. Inténtalo de nuevo más tarde.',
                timer: 2000,
                showConfirmButton: false,
            });
        }
    };
};


